@if (show()) {
    <div class="loader-overlay">
        <div class="loader-backdrop"></div>
        <span class="loader"></span>
    </div>
}
